import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { RestService } from '../rest.service';
import * as Chart from 'chart.js'
import * as jsPDF from 'jspdf';
// import * as html2canvas from "html2canvas";
import { ExcelexportService } from '../excelexport.service';

@Component({
  selector: 'app-graficas-conjuntas',
  templateUrl: './graficas-conjuntas.component.html',
  styleUrls: ['./graficas-conjuntas.component.scss']
})
export class GraficasConjuntasComponent implements OnInit {

  chart1;
  chart9;

  checkbox_value = false;

  cups: any[] = [];
  items: any[] = [];

  year = '2018';

  optionsdt: DataTables.Settings = {};
  triggerdt: Subject<any> = new Subject();

  constructor(public rest: RestService, private excel: ExcelexportService) { }

  ngOnInit() {
    this.optionsdt = {
      pagingType: 'full_numbers',
      pageLength: 15,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_',
        info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      }
    };
    this.getPoints();
  }

  exportAsXLSX(): void {
    if (this.cups.length === 0) {
      for (let index = 0; index < this.items.length; index++) {
        this.excel.export2Chart(this.items[index]['graficas'], this.items[index]['cup'].toString() + '_' + this.items[index]['year']);
      }
      this.items.forEach(item => {
      });
    } else if (this.cups.length !== 0) {
      for (let jindex = 0; jindex < this.cups.length; jindex++) {
        this.excel.export2Chart(this.cups[jindex]['graficas'], this.cups[jindex]['cup'].toString() + '_' + this.cups[jindex]['year']);
      }
      this.items.forEach(item => {
      });
    }
  }

  deletePush() {
    this.cups = [];
    if (this.chart1) { this.chart1.destroy(); }
    if (this.chart9) { this.chart9.destroy(); }
    this.checkbox_value = false;
  }

  getPoints() {
    this.rest.getPuntos(this.year).subscribe((data) => {
      this.items = data['data'];
      this.triggerdt.next();
    });
  }

  getRePoints() {
    const destroy = new Promise(
      (resolve, reject) => {
        this.triggerdt.unsubscribe();
        resolve();
      }
    );
    this.rest.getPuntos(this.year).subscribe((data) => {
      this.items = data['data'];
      this.triggerdt.next();
    })
  }

  anadir_cup(value) {
    this.cups.push(value);

    console.log(this.cups);
    
    if (this.chart1) { this.chart1.destroy(); }
    if (this.chart9) { this.chart9.destroy(); }

    // Chart 1
    const c1l1: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1l2: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1l3: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1b1: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1b2: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1b3: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    // Chart 9
    const c9l1: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9l2: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9l3: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9b1: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9b2: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9b3: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    // CHARTS
    for (let jindex = 0; jindex < this.cups.length; jindex++) {

      // Chart 1
      if (this.cups[jindex]['graficas'][0].hasOwnProperty('data')) {

        const promise0 = new Promise( (resolve ) => {

          for (let i = 0; i < this.cups[jindex]['graficas'][0]['data'].length; i++) {

            c1l1[i] += this.cups[jindex]['graficas'][0]['data'][i]['consumoAcumAA'];
            c1l2[i] += this.cups[jindex]['graficas'][0]['data'][i]['consumoAcum'];
            c1l3[i] += this.cups[jindex]['graficas'][0]['data'][i]['ahorroAcum'];
            c1b1[i] += this.cups[jindex]['graficas'][0]['data'][i]['consumoAA'];
            c1b2[i] += this.cups[jindex]['graficas'][0]['data'][i]['consumo'];
            c1b3[i] += this.cups[jindex]['graficas'][0]['data'][i]['ahorro'];
          }
          resolve();
        });

        promise0.then( (ok) => {
          this.chart1 = this.mixedChart('mix1', c1l1, c1l2, c1l3, c1b1, c1b2, c1b3, 'Evolucion termino factura total');
        });
      }

      // Chart 9
      if (this.cups[jindex]['graficas'][8].hasOwnProperty('data')) {

        console.log('1');
        const promise9 = new Promise( (resolve ) => {

          console.log('2');

          for (let i2 = 0; i2 < this.cups[jindex]['graficas'][8]['data'].length; i2++) {

            console.log('3');
            
            c9l1[i2] += this.cups[jindex]['graficas'][8]['data'][i2]['consumoAcumAA'];
            c9l2[i2] += this.cups[jindex]['graficas'][8]['data'][i2]['consumoAcum'];
            c9l3[i2] += this.cups[jindex]['graficas'][8]['data'][i2]['ahorroAcum'];
            c9b1[i2] += this.cups[jindex]['graficas'][8]['data'][i2]['consumoAA'];
            c9b2[i2] += this.cups[jindex]['graficas'][8]['data'][i2]['consumo'];
            c9b3[i2] += this.cups[jindex]['graficas'][8]['data'][i2]['ahorro'];
          }
          resolve();
        });

        promise9.then( (ok) => {
          this.chart9 = this.mixedChart('mix9', c9l1, c9l2, c9l3, c9b1, c9b2, c9b3, 'Evolución energia activa consumida [kWh]');
        });
      }

    }


  }

  private mixedChart(name, dataline1, dataline2, dataline3, databar1, databar2, databar3, nameText) {
    return new Chart(document.getElementById(name), {
      type: 'bar',
      data: {
        labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        datasets: [
          {
            label: 'Linea-AA',
            type: 'line',
            borderColor: '#b2bbc3',
            data: dataline1,
            fill: false,
            yAxisID: 'right-y-axis'
          }, {
            label: 'Linea-Actual',
            type: 'line',
            borderColor: '#4cc3ea',
            data: dataline2,
            fill: false,
            yAxisID: 'right-y-axis'
          }, {
            label: 'Linea-Ahorro',
            type: 'line',
            borderColor: '#118a11',
            data: dataline3,
            fill: false,
            yAxisID: 'right-y-axis'
          }, {
            label: 'Barra-AA',
            type: 'bar',
            backgroundColor: '#708090',
            backgroundColorHover: '#35bcec',
            data: databar1,
            yAxisID: 'left-y-axis'
          }, {
            label: 'Barra-Ac',
            type: 'bar',
            backgroundColor: '#add8e6',
            backgroundColorHover: '#4698b3',
            data: databar2,
            yAxisID: 'left-y-axis',
          }, {
            label: 'Barra-Ahorro',
            type: 'bar',
            backgroundColor: '#90ee90',
            backgroundColorHover: '#39a239',
            data: databar3,
            yAxisID: 'left-y-axis'
          }]

      },
      options: {
        title: {
          display: true,
          text: nameText
        },
        scales: {
          yAxes: [{
            id: 'left-y-axis',
            type: 'linear',
            position: 'left'
          }, {
            id: 'right-y-axis',
            type: 'linear',
            position: 'right'
          }]
        },
        legend: { display: true },
        maintainAspectRatio: false,
        responsive: true
      }
    });
  }

  /*public downloadPDF() {
    let doc = new jsPDF('landscape');
    html2canvas(document.body)
      .then(canvas => {
        var imgData = canvas.toDataURL('image/png", 1.0);
        doc.addImage(imgData, 'JPEG', -50, -10, 350, 220);
        doc.save('Chart.pdf');
      });
  }*/

}